import AboutPage from "../Components/AboutPage";

function About() {
    return (
       <AboutPage />
    );
}

export default About;